<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<app-logo-card-page [style]="style">
    <h1>{{fHeader}}</h1>
    <p>{{fAutoDownload}}
        <a [routerLink]="[]" (click)="onDownloadOnlyClick()">{{fClickHere}}</a>.
    </p>

    <h2>{{fEmailVerify}}</h2>

    <p>{{fEmailA}}
        {{fEmailB}}
        {{fEmailC}}</p>

    <p>{{fInfo}}
        <a href="https://www.cigent.com/resources">{{fLink}}</a></p>

    <p>{{fThanks}}</p>
</app-logo-card-page>
